import React from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../actions';
import ShowMoreLink from '../../design/ShowMoreLink';

class ShowHideRepliesLink extends React.Component {

  constructor(props) {
    super(props);
    this.showAllReplies = this.showAllReplies.bind(this);
    this.showAllRepliesCallback = this.showAllRepliesCallback.bind(this);
    this.hideReplies = this.hideReplies.bind(this);
  }

  showAllReplies() {
    this.props.showSmallSpinner();

    const endpoint = routes().get_comment_replies;
    const data = {
      parent_id: this.props.comment.id,
      parent_type: this.props.comment.comment_type
    };
    getWithData(endpoint, data, this.showAllRepliesCallback, this);
  }

  showAllRepliesCallback(data) {
    this.props.setRepliesFor(
      data.pop_comment_replies[0].commented_id,
      data.pop_comment_replies[0].commented_type,
      data.pop_comment_replies
    );
    this.props.hideSmallSpinner();
  }

  hideReplies(e) {
    e.preventDefault();
    this.props.showSmallSpinner();
    this.props.cutRepliesFor(this.props.comment.id, this.props.comment.comment_type);
    this.props.hideSmallSpinner();
  }

  render() {
    if (this.props.comment.pop_comment_replies_count < 3) {
      return null;
    } else if (this.props.comment.replies.length < this.props.comment.pop_comment_replies_count) {
      return (
        <ShowMoreLink
          onClick={this.showAllReplies}
          text={`${I18n.t('components.webreader_comments_list_item.show_all_replies')} (${this.props.comment.pop_comment_replies_count})`}
        />
      );
    } else {
      return (
        <ShowMoreLink
          path={EMPTY_HREF}
          onClick={this.hideReplies}
          text={I18n.t('components.webreader_comments_list_item.hide_replies')}
        />
      );
    }
  }
}

const mapState = () => ({});

const mapDispatch = dispatch => ({
  cutRepliesFor: (commentedId, commentedType) => { dispatch(actions.cutRepliesFor(commentedId, commentedType)); },
  setRepliesFor: (commentedId, commentedType, replies) => {
    dispatch(actions.setRepliesFor(commentedId, commentedType, replies));
  },
  showSmallSpinner: () => { dispatch(actions.showSmallSpinner()); },
  hideSmallSpinner: () => { dispatch(actions.hideSmallSpinner()); }
});

export default connect(mapState, mapDispatch)(ShowHideRepliesLink);
